import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { useLocation } from "react-router-dom";

import Navbar from "./Navbar";
import Footer from "./Footer";
import "./CancellationPolicy.css";

const CancellationPolicy = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const [ready, setReady] = useState(false);

  // same lang-from-URL logic as PrivacyPolicy
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const lang = params.get('lang');

    if (lang && lang !== i18n.language) {
      i18n.changeLanguage(lang).then(() => {
        setReady(true);
      });
    } else {
      setReady(true);
    }
  }, [location, i18n]);

  if (!ready) return null;

  // renders **marked** parts of a translation string in bold
  const renderBold = (text) =>
    text.split('**').map((part, index) =>
      index % 2 === 1 ? <strong key={index}>{part}</strong> : part
    );

  // turns the contact email inside a translation string into a mailto link
  const EMAIL = "hello@ondrejstaidl.com";
  const renderWithEmailLink = (text) =>
    text.split(EMAIL).flatMap((part, index, parts) =>
      index < parts.length - 1
        ? [part, <a key={index} href={`mailto:${EMAIL}`}>{EMAIL}</a>]
        : [part]
    );

  const tiers = t('cancellationPolicy.sections.clientCancellation.tiers.rows', { returnObjects: true });
  const reasons = t('cancellationPolicy.sections.providerCancellation.reasons', { returnObjects: true });
  const languageNote = t('cancellationPolicy.languageNote');

  return (
    <div>
      <Navbar />

      <main className="container cancellation-policy-content">
        <h1>{t('cancellationPolicy.header')}</h1>
        <h4>{t('cancellationPolicy.lastUpdated')}</h4>

        {/* Section 1 – cancellation by the client */}
        <h2>{t('cancellationPolicy.sections.clientCancellation.title')}</h2>
        <p>{renderWithEmailLink(t('cancellationPolicy.sections.clientCancellation.description'))}</p>
        <p>{t('cancellationPolicy.sections.clientCancellation.tiersIntro')}</p>

        <div className="storno-table-wrapper">
          <table className="storno-table">
            <thead>
              <tr>
                <th>{t('cancellationPolicy.sections.clientCancellation.tiers.periodHeader')}</th>
                <th>{t('cancellationPolicy.sections.clientCancellation.tiers.feeHeader')}</th>
              </tr>
            </thead>
            <tbody>
              {tiers.map((row, index) => (
                <tr key={index}>
                  <td>{renderBold(row.period)}</td>
                  <td>
                    <strong>{row.fee}</strong>
                    {row.note && <span className="storno-table-note">{row.note}</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Section 2 – substitute participant */}
        <h2>{t('cancellationPolicy.sections.substitute.title')}</h2>
        <p>{t('cancellationPolicy.sections.substitute.description')}</p>

        {/* Section 3 – cancellation by the provider */}
        <h2>{t('cancellationPolicy.sections.providerCancellation.title')}</h2>
        <p>{t('cancellationPolicy.sections.providerCancellation.description')}</p>
        <ul>
          {reasons.map((reason, index) => (
            <li key={index}>{reason}</li>
          ))}
        </ul>
        <p>{t('cancellationPolicy.sections.providerCancellation.outcome')}</p>

        {languageNote && <p className="language-note">{languageNote}</p>}
      </main>

      <Footer />
    </div>
  );
};

export default CancellationPolicy;
